import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import { CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import Typography from '@material-ui/core/Typography'
import report from '../../../assets/cnp/seo-report.png'
import tractor from '../../../assets/cnp/tractor.png'
import wheat from '../../../assets/cnp/wheat.png'
import yara from '../../../assets/cnp/yara-logo.png'

const useStyles = makeStyles((theme) => ({
	prgList: {
		height: 500,
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
	},
}))

function CNPDescription({ setCreateCNP, width }) {
	const classes = useStyles()
	return (
		<React.Fragment>
			<Grid
				container
				direction="row"
				spacing={5}
				className={classes.paper}
			>
				<Grid item xs={12}>
					<img src={yara} style={{ width: '100%' }} />
				</Grid>
				<Grid item xs={12}>
					<Typography variant="h5">
						Crear plan de nutrición de cultivos
					</Typography>
					<Typography>
						Para obtener una lista completa de planes de nutrición y
						productos recomendados para su explotación, necesita un
						plan de nutrición activo. Seleccione Crear plan de
						nutrición.
					</Typography>
				</Grid>
				<Grid item xs={4}>
					<img src={report} style={{ width: 80 }} />
					<Typography variant="subtitle1">
						Descubra qué necesita su cultivo
					</Typography>
					<Typography variant="body2">
						Al proporcionar algunos parámetros básicos de entrada de
						parcela y cultivo, podemos crear un plan de nutrición
						para el ciclo completo del cultivo.
					</Typography>
				</Grid>
				<Grid item xs={4}>
					<img src={tractor} style={{ width: 80 }} />
					<Typography variant="subtitle1">
						Sepa cuándo aplicar qué producto y en qué cantidad
					</Typography>
					<Typography variant="body2">
						El plan de nutrición de ciclo completo se dividirá en
						consejos específicos por fase de crecimiento del cultivo
						para optimizar el impacto de fertilizantes y nutrientes.
					</Typography>
				</Grid>
				<Grid item xs={4}>
					<img src={wheat} style={{ width: 80 }} />
					<Typography variant="subtitle1">
						Aumente el rendimiento de sus cultivos
					</Typography>
					<Typography variant="body2">
						Al aplicar el plan de nutrición, su cultivo se
						beneficiará de las mejores condiciones de fertilizantes
						y nutrientes para alcanzar su rendimiento y calidad.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Button
						color="primary"
						size="small"
						variant="outlined"
						style={{ width: '100%' }}
						onClick={() => setCreateCNP(true)}
					>
						Crear plan de nutrición
					</Button>
				</Grid>
			</Grid>
		</React.Fragment>
	)
}

export default withWidth()(CNPDescription)
